export const REPORTS_CLAIMS_AUTORUN_FROM_DASHBOARD_KEY =
  "reportsClaimsAutoRunFromDashboard";
